/**
 * Subscription Management Platform API
 * This document describes the functionality of the API belonging to the Subscription Management Platform ## Parameters ### Parameters with type \"array[string]\" or \"array[integer]\" should be given as multiple parameters with same key and different values    * param=A&param=B&param=C    * param=0&param=1&param=2
 *
 * OpenAPI spec version: 2.0.7
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface SUBSCRIPTIONINFO {
    /**
     * International Mobile Subscriber Identity
     */
    imsi?: string;
    /**
     * Mobile Subscriber Integrated Services Digital Network Number
     */
    msisdn?: string;
    /**
     * Mobile Network Operator ID
     */
    mnoId: string;
    country?: string;
    /**
     * Integrated Circuit Card ID
     */
    iccid: string;
    status: SUBSCRIPTIONINFO.StatusEnum;
    downloadDate?: Date;
    /**
     * ISDP AID
     */
    isdpAid: string;
    /**
     * ID of the DP instance
     */
    dpId?: string;
    fallback: boolean;
    profileType?: string;
    allocatedMemory: number;
    freeMemory?: number;
}
export namespace SUBSCRIPTIONINFO {
    export type StatusEnum = 'CREATED' | 'ENABLED' | 'DISABLED';
    export const StatusEnum = {
        CREATED: 'CREATED' as StatusEnum,
        ENABLED: 'ENABLED' as StatusEnum,
        DISABLED: 'DISABLED' as StatusEnum
    }
}



// WEBPACK FOOTER //
// ./src/gen/swagger-api/model/sUBSCRIPTIONINFO.ts